var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ffffff;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path-1_00000173869444359553284320000005825465462082550185_",
    className: "st0",
    d: "M22.8,17.4c0.4,0.4,0.4,1,0,1.4 c-0.4,0.4-0.9,0.4-1.3,0.1l-0.1-0.1l-6-5.9l-6.3,6c-0.4,0.4-0.9,0.4-1.3,0l-0.1-0.1c-0.4-0.4-0.4-0.9,0-1.3l0.1-0.1l7-6.6 c0.4-0.3,0.9-0.4,1.3-0.1l0.1,0.1L22.8,17.4z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpWhite);
export default __webpack_public_path__ + "static/media/up_white.60fbc2b72b8d0db9b8d40aa11510bdac.svg";
export { ForwardRef as ReactComponent };